function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-515e5eba\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!../../../node_modules/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./Selector.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!../../../node_modules/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./Selector.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-515e5eba\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!../../../node_modules/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./Selector.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-515e5eba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/leaf-relief/Selector.vue
// module id = 620
// module chunks = 0